import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, take } from 'rxjs';
import { APPLICATIONJSON, PAGE, SECTION, THEME, WIDGET  } from '../../models/app-json';
import { ActivatedRoute, Router } from '@angular/router';
import { FORMI, PAGEI, PAGE_CONFIGI } from '../../models/page_config_json';
import { LAST_SELECTED_OPTION, PAGETYPES, WIDGET_TYPES } from '../../constants/proj.cnst';
import { ToastrService } from 'ngx-toastr';
import { CATEGORIES_META_DATA } from '../../constants/widgets_meta_config_cnsts';
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping } from 'shared-library';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  applicationMetaInfo: any;
  userMetaInfo: any;
  themeData: any;
  entireAppData:any
  pageTypes = PAGETYPES;
  constructor(private route: ActivatedRoute,
      private dataService: VlDataService,
      private httpService: VlHttpService,
      private activatedRoute: ActivatedRoute,
      private toastrSer : ToastrService,
      private router: Router,) {
        this.router.events.subscribe((val: any) => {
          this.userMetaInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string) : null;
        })
        const storedBreadcrumb = localStorage.getItem('breadcrumb');
        if (storedBreadcrumb) {
          this.breadcrumbSubject.next(JSON.parse(storedBreadcrumb));
        }
  }

  //#region this is used for setting and displaying sidenav-content

  private selectedOptionSubject = new BehaviorSubject<SidenavOption>({ label: 'default', isActive: false });

  selectedOption$: Observable<SidenavOption> = this.selectedOptionSubject.asObservable();

  private showMenuStatusSubject = new BehaviorSubject<boolean>(false);

  showMenuStatus$: Observable<boolean> = this.showMenuStatusSubject.asObservable();

  private getAllPagesRefreshAction = new BehaviorSubject<boolean>(false);
  getAllPagesRefreshAction$: Observable<boolean> = this.getAllPagesRefreshAction.asObservable();

  private pageDataSubject = new BehaviorSubject<any>(null);
  pageData$ = this.pageDataSubject.asObservable();

  setPageData(pageName: any) {
    this.pageDataSubject.next(pageName);
  }

  getAllPagesRefreshActionTrigger() {
    this.getAllPagesRefreshAction.next(true);
  }

  getShowMenuStatus()
  {
    return this.showMenuStatusSubject.value;
  }

  setShowMenuStatus(value:boolean)
  {
    this.showMenuStatusSubject.next(value);
  }

  private logoutUserSubject = new BehaviorSubject<boolean>(false);

  logoutUser$: Observable<boolean> = this.logoutUserSubject.asObservable();

  setlogoutUserStatus(value:boolean)
  {
    this.showMenuStatusSubject.next(value);
  }

  private workFlowSubject = new BehaviorSubject<any>({});
  workflowSubject$: Observable<any> = this.workFlowSubject.asObservable();

  setWorkFlowSubject(value: any) {
    this.workFlowSubject.next(value);
  }

  private stepperIndexSource = new BehaviorSubject<boolean>(false);
  currentStepperIndex = this.stepperIndexSource.asObservable();
  
  
  private onMobileScreenDropSubject = new BehaviorSubject<any>({});
  onMobileScreenDropSubjectdata$: Observable<any> = this.onMobileScreenDropSubject.asObservable();

  private sideNavListSubject = new BehaviorSubject<any>({});
  sideNavListSubjectData$: Observable<any> = this.sideNavListSubject.asObservable();

  private widgetLabelSubject = new BehaviorSubject<{ label: string, widgetId: string }>({ label: '', widgetId: '' }); // Initial value can be set if needed
  widgetLabel$ = this.widgetLabelSubject.asObservable();
  
  setWidgetLabel(label: string, widgetId: string) {
    this.widgetLabelSubject.next({ label, widgetId });
  }


  private widgetPlaceholderSubject = new BehaviorSubject<{ placeholder: string, widgetId: string }>({ placeholder: '', widgetId: '' }); // Initial value can be set if needed
  widgetPlaceholder$ = this.widgetPlaceholderSubject.asObservable();
  
  setWidgetPlaceholder(placeholder: string, widgetId: string) {
    this.widgetPlaceholderSubject.next({ placeholder, widgetId });
  }

  private widgetTextColorSubject = new BehaviorSubject<{ textColor: string, widgetId: string }>({ textColor: '', widgetId: '' }); // Initial value can be set if needed
  widgetTextColor$ = this.widgetTextColorSubject.asObservable();
  
  setWidgetTextColor(textColor: string, widgetId: string) {
    this.widgetTextColorSubject.next({ textColor, widgetId });
  }

  private breadcrumbSubject = new BehaviorSubject<{ id: any; label: any , state: any}[]>([]);
  breadcrumb$ = this.breadcrumbSubject.asObservable();

  updateBreadcrumb(breadcrumb: { id: any; label: any, state: any}[]) {
    this.breadcrumbSubject.next(breadcrumb);
    localStorage.setItem('breadcrumb', JSON.stringify(breadcrumb));
  }

  getBreadcrumb(): Observable<{ id: any; label: any, state: any }[]> {
    return this.breadcrumb$;
  }

  clearBreadcrumb() {
    this.breadcrumbSubject.next([]);
    localStorage.removeItem('breadcrumb');
    localStorage.removeItem('webAppInfo');
  }

  getCurrentBreadcrumb(): { id: any; label: any, state: any}[] {
    return this.breadcrumbSubject.getValue();
  }

  navigateByBreadcrumb(data: any, index: any){
    if(index == 0){
      this.clearBreadcrumb();
      this.router.navigate(['home']);
    }

    if(index == 1){
      const currentBreadcrumb = this.getCurrentBreadcrumb();
      const newBreadcrumb  = currentBreadcrumb.slice(0,index+1);
      this.updateBreadcrumb(newBreadcrumb);
      this.router.navigate(['home','applications'], {
        queryParams: {
          "id":data.id,
          "projectName":data.label
        }
      });
    }

    if(index == 2 && data.state === 'mobile'){
      const currentBreadcrumb = this.getCurrentBreadcrumb();
      const newBreadcrumb  = currentBreadcrumb.slice(0,index+1);
      this.updateBreadcrumb(newBreadcrumb);
      this.router.navigate(['home','mobile'], {
        queryParams: {
          "id":data.id
        }
      });
    }  

    if(index == 2 && data.state === 'web'){
      const currentBreadcrumb = this.getCurrentBreadcrumb();
      const newBreadcrumb  = currentBreadcrumb.slice(0,index+1);
      this.updateBreadcrumb(newBreadcrumb);
      this.router.navigate(['home','web']);
    }  
  }

  onMobileScreenDropUpdateData(data: any) {
    this.onMobileScreenDropSubject.next(data);
  }

  onMobileScreenClearData() {
    let data = {};
    this.onMobileScreenDropSubject.next(data);
  }



  onSideNavListUpdateData(data: any) {
    this.sideNavListSubject.next(data);
  }

  setSelectedOption(label: string, isActive: boolean) {
    const option: SidenavOption = { label, isActive };
    this.selectedOptionSubject.next(option);
  }
  getSelectedOption(){
    return this.selectedOptionSubject.value;
  }
  //#endregion

  //#region this is used for setting and displaying sidenav-content-list
  private sidenavContentlistSubject = new BehaviorSubject<SideNavOptionForPages>({
    id: '',
    isActive: false
  });

  sidenavContentlistSubject$: Observable<SideNavOptionForPages> = this.sidenavContentlistSubject.asObservable();

  setSidenavContentlistOption(id: string, isActive: boolean) {
    const option: SideNavOptionForPages = { id, isActive };
    this.sidenavContentlistSubject.next(option);
  }

  getSidenavContentlist()
  {
    return this.sidenavContentlistSubject.value;
  }

  private WidgetListStatusSubject = new BehaviorSubject<boolean>(false);

  WidgetListStatus$: Observable<boolean> = this.WidgetListStatusSubject.asObservable();

  setWidgetListStatus(value: boolean) {
    
    this.WidgetListStatusSubject.next(value);
  }

  getSideNavStatus()
  {
    return this.WidgetListStatusSubject.value;
  }

  //#endregion

  //#region  this is for  pages 

  private pagesListSubject1 = new BehaviorSubject<PAGEI[]>([]);
  pages1$: Observable<PAGEI[]> = this.pagesListSubject1.asObservable();
  private defpagesListSubject1 = new BehaviorSubject<PAGEI[]>([]);
  defpages$: Observable<PAGEI[]> = this.defpagesListSubject1.asObservable();
 
  formatPageBeforeUpdate(data: PAGE[]) {
    let appData: APPLICATIONJSON = localStorage.getItem("application") ? JSON.parse(localStorage.getItem("application") as string) : {};
    const currentParams = { ...this.route.snapshot.queryParams };
    appData.pages = appData.pages.map((page: PAGE) => {
      if (page.pageID === currentParams['pageId']) {
        const updatedPage = data.find((updatedPage: PAGE) => updatedPage.pageID === currentParams['pageId']);
        if (updatedPage) {
          return { ...page, pageName: updatedPage.pageName, section: updatedPage.section };
        }
      }
      return page;
    });
    this.updateApplication(appData);
  }

  formatPageBeforeUpdate1(data:PAGEI[]) {

  }

  formatAppBeforeUpdate(data: PAGE[]) {
    let appData: APPLICATIONJSON = localStorage.getItem("application") ? JSON.parse(localStorage.getItem("application") as string) : {};
    const currentParams = { ...this.route.snapshot.queryParams };
    appData.pages = data;
    this.updateApplication(appData);
  }

  addPageData(applicationId: string,pageName:any):Observable<any> {
    let returnTypes:any = {
      placed : false,
      exits:false,
      failed:false
    }
    let theme : THEME = this.themesSubject.value;
    let pageStyle = {
      backgroundColor: theme.defaultBackgroundColor
    }
    let pageLength = this.pagesListSubject1.value.length;
    const page_config: PAGE_CONFIGI = {
      style : pageStyle,
      actions: [],
      additionalConfig: {},
      pageForms : [],
      forms : []
    } 
    const pagePostData: PAGEI = {
      applicationId: applicationId,
      pageName: pageName,
      pageConfig: page_config,
      pageType:this.pageTypes.customPage
    }
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_PAGE']);
    apiConfig.postData = pagePostData
    return new Observable((observer) => {
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        pagePostData.pageId = data.pageId;
        const updatedPages = [...this.pagesListSubject1.value, pagePostData];
        this.pagesListSubject1.next(updatedPages);
        observer.next(data); 
        observer.complete();
      },
      error: (data: any) => {
        observer.error(data); 
        observer.complete(); 
      }
    })})
  }

  updatePageData(pagePostData: PAGEI): Observable<any> {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_PAGE']);
    let userInfoString: any = localStorage.getItem('userInfo');
    let userId;
    if (userInfoString !== null) {
      const userInfo = JSON.parse(userInfoString);
       userId = userInfo.userId;
    }
    apiConfig.postData = pagePostData;
    apiConfig.postData['userId'] = userId;
    return new Observable((observer) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          pagePostData.pageId = data?.pageId;
          let previousPagesData = this.pagesListSubject1.value;
          previousPagesData = previousPagesData.map((page: PAGEI) => (page.pageId == pagePostData.pageId ? pagePostData : page));
          observer.next(data); 
          observer.complete(); 
        },
        error: (error: any) => {
          observer.error(error); 
          observer.complete(); 
        }
      });
    });
  }
  

  copyPage(pageId: string,applicationId:string): any {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['COPY_PAGE']);
      apiConfig.postData = { pageId: pageId,applicationId:applicationId };
  
     return this.httpService.placeAPICall(apiConfig)
  }
  
  async deletePage(pageId: string,forceDelete:any): Promise<{ success: boolean, message?:any }> {
    return new Promise<{ success: boolean, message?: any }>((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_PAGE']);
      apiConfig.postData = { page_id: pageId,force_delete:forceDelete };
  
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          if(forceDelete == 'False'){
            resolve({ success: false,message:data});
          }else{
            this.getAllPages();
            resolve({ success: true });
          }
        },
        error: (data: any) => {
            this.toastrSer.error('Failed to delete page', 'Error');
        }
      });
    });
  }

  getAllDefaultPages(applicationTypeId : string){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_MASTER_PAGES']);
    apiConfig.postData = {application_type_id: applicationTypeId};
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.defpagesListSubject1.next(data);
      },
      error: (err: any) => {
        this.defpagesListSubject1.next([])
      }
    })
    return this.defpages$;
  }

  async createAllDefaultPages(applicationId : string, defaultPageJson : any,landingPageNavConfig?:any): Promise<any>{
    return await new Promise((resolve, reject) => {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_MASTER_PAGES']);

    apiConfig.postData = {
      applicationId: applicationId,
      defaultPages: defaultPageJson,  
    };
    if(landingPageNavConfig){
      apiConfig.postData['landingPageNavConfig'] = landingPageNavConfig
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        resolve(data);
      },
      error: (err: any) => {
        reject(err);
      }
    })
  })
  }

  getAllPages() {
    const currentParams = { ...this.route.snapshot.queryParams };
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGES']);
    apiConfig.postData = {application_id: currentParams['id']}
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.pagesListSubject1.next(data);
      },
      error: (err: any) => {
        this.pagesListSubject1.next([])
      }
    })
  }

  getPages(){
    return this.pagesListSubject1.value;
  }

  public updatePages(pages: PAGEI[]): void {
    this.pagesListSubject1.next(pages);
  }


  async getAlldefaultPages(applicationId: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGES']);
      apiConfig.postData = { application_id: applicationId };
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          resolve(data); // Resolve the Promise with the fetched data
        },
        error: (err: any) => {
          reject(err); // Reject the Promise with the error
        },
      });
    });
  }

  getPageById(pageId: string): any {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGE']);
    apiConfig.postData = {page_id: pageId}
    return this.httpService.placeAPICall(apiConfig);
  }


  updateApplication(jsonData: APPLICATIONJSON) {
    localStorage.setItem("application", JSON.stringify(jsonData));
  }

  addSection(pageId: string, section: SECTION,currentPageData: PAGEI): Observable<any> {
    return new Observable((observer) => {
      let updatedList: PAGEI[] = [];
      this.pagesListSubject1.pipe(take(1)).subscribe((currentList) => {
        currentList.forEach((page: PAGEI) => {
          if (pageId === page.pageId) {
            page.sections = page.sections ? page.sections : [];
            let formType = section.sectionType;
            const currentParams = { ...this.route.snapshot.queryParams };
            let Sectionindex = currentPageData.forms.findIndex((form: any) => form.formConfig.formType === 'section');
            if(section.sectionType == 'Navgation Bar') {
              let formPostData: FORMI = {
                applicationId : currentParams['id'],
                pageId: pageId,
                formLabel: section.name,
                formKey: section.key,
                formVersion: 1,
                entityKey: '2324',
                createdBy: 'user1',
                parentEntityKey: pageId,
                formConfig: {
                  style : section.style,
                  actions: [],
                  formsWidgets: [],
                  formType : formType,
                  customStyleApplied:false,
                },
                
              };
              (formPostData?.formConfig as any)['enable'] = true;
              let formId = '';
              this.createForm(formPostData).subscribe((res: any) => {
                if(res) {
                    section.sectionId = res['formId'];
                    formId = res['formId'];
                    currentPageData.pageConfig?.pageForms?.unshift(section.sectionId);
    
                    let pagePostData = {
                      applicationId:currentParams['id'],
                      pageId : page.pageId,
                      pageForms :  currentPageData.pageConfig?.pageForms,
                      style:currentPageData.pageConfig?.style
                    }

                    let index = currentPageData.forms.findIndex((form: any) => form.formConfig.formType === 'Navgation Bar');

                    this.updatePageData(pagePostData as any).subscribe((res) => {
                    this.AddWidgetsInExistingForm(section,section.sectionId,currentParams['id'],currentPageData,0).subscribe((value: any) => {
                      observer.next(true);
                      observer.complete();
                    })
                   
                  })
                }
              })
            }
            else if(section.sectionType == 'menuPanel'){
              let formPostData: FORMI = {
                applicationId : currentParams['id'],
                pageId: pageId,
                formLabel: section.name,
                formKey: section.key,
                formVersion: 1,
                entityKey: '2324',
                createdBy: 'user1',
                parentEntityKey: pageId,
                formConfig: {
                  style : section.style,
                  actions: [],
                  formsWidgets: [],
                  formType : formType,
                  customStyleApplied:false,
                },
                
              };
              let formId = '';
              this.createForm(formPostData).subscribe((res: any) => {
                if(res) {
                    section.sectionId = res['formId'];
                    formId = res['formId'];
                    currentPageData.pageConfig?.pageForms?.push(section.sectionId);
    
                    let pagePostData = {
                      applicationId:currentParams['id'],
                      pageId : page.pageId,
                      pageForms :  currentPageData.pageConfig?.pageForms,
                      style:currentPageData.pageConfig?.style
                    }
                    
                    let index = currentPageData.forms.findIndex((form: any) => form.formConfig.formType === 'menuPanel');

                    this.updatePageData(pagePostData as any).subscribe((res) => {
                    this.AddWidgetsInExistingForm(section,section.sectionId,currentParams['id'],currentPageData,index).subscribe((value: any) => {
                      observer.next(true);
                      observer.complete();
                    })
                   
                  })
                }
              })
            }
            // else if((currentPageData.forms?.[0]?.formConfig?.formType == 'Navgation Bar' && currentPageData?.forms?.length < 2) || (currentPageData.forms?.[0]?.formConfig?.formType !== 'Navgation Bar' && currentPageData?.forms?.length < 1)) {
            else if(Sectionindex === -1) {
              let formPostData: FORMI = {
                applicationId : currentParams['id'],
                pageId: pageId,
                formLabel: section.name,
                formKey: section.key,
                formVersion: 1,
                entityKey: '2324',
                createdBy: 'user1',
                parentEntityKey: pageId,
                formConfig: {
                  style : section.style,
                  actions: [],
                  formsWidgets: [],
                  formType : formType,
                  customStyleApplied:false,
                },
                
              };
              // let formIndex = currentPageData.forms?.[0]?.formConfig?.formType == 'Navgation Bar' && currentPageData?.forms?.length < 2 ? 1 : 0
              let formId = '';
              this.createForm(formPostData).subscribe((res: any) => {
                if(res) {
                    section.sectionId = res['formId'];
                    formId = res['formId'];
                    currentPageData.pageConfig?.pageForms?.push(section.sectionId);
    
                    let pagePostData = {
                      applicationId:currentParams['id'],
                      pageId : page.pageId,
                      pageForms :  currentPageData.pageConfig?.pageForms,
                      style:currentPageData.pageConfig?.style
                    }
                    let formIndex = currentPageData.forms.findIndex((form: any) => form.formConfig.formType === 'section');
                    this.updatePageData(pagePostData as any).subscribe((res) => {
                    this.AddWidgetsInExistingForm(section,section.sectionId,currentParams['id'],currentPageData,formIndex).subscribe((value: any) => {
                      observer.next(true);
                      observer.complete();
                    })
                   
                  })
                }
              })
            }
            else {
              let  formId! :string; 
              let formIndex = currentPageData.forms.findIndex((form: any) => form.formConfig.formType === 'section');
               formId = currentPageData.forms[formIndex].formId;
              this.AddWidgetsInExistingForm(section,formId,currentParams['id'],currentPageData,formIndex).subscribe((value: any) => {
                observer.next(true);
                observer.complete();
              })
             
              
            }
            page.sections?.push(section);
            updatedList.push(page);
          } else {
            updatedList.push(page);
          }
        });
      })
    })

  }

  AddWidgetsInExistingForm(section : SECTION, formId: string, applicationId: string, currentPageData: PAGEI,formIndex: number) : Observable<any> {
    return new Observable((observer) => {
      if(section.widgets) {
        let listOfWidgetsConfig: any = [];
        section.widgets.forEach( (widget : any) => {
          
          let element = {}
          if(widget.element){
             element= {
              showLabel:widget.element.showLabel,
              isRequired:widget.element.isRequired,
              filedname:widget.element.filedname,
              placeholderText:widget.element.placeholderText,
              label:widget.element.label
  
            }
          }
           
          let dataSource = {}
          if(widget.widgetType == WIDGET_TYPES.radio){
            dataSource = {
              "datasourceType": "manual",
              "datasource": [
                  {
                      "key": "",
                      "label": "value1"
                  },
                  {
                      "key": "",
                      "label": "value2"
                  }
              ]
          }
          }
  
          let widgetPostData:any = {
            formId:formId,
            applicationId : applicationId,
            widgetLabel : widget.element?.label ? widget.element?.label : widget.name,
            widgetKey : widget.key,
            widgetType : widget.widgetType,
            widgetConfig : {
              label:widget?.element?.label ? widget.element?.label : '',
              customStyleApplied: widget.customStyleApplied,
              placeholderText: widget?.element?.placeholderText,
              showlabel: widget.element?.showLabel,
              showDeletebutton: widget.showDeleteButton,
              style: widget.style,
              type: widget.type,
              validations: widget.validations,
              actions: widget.actions && widget.actions.length > 0 ? widget.actions : [],
              element:element,
              additionalConfig: widget.additionalConfig ?? {},
              enabled: widget?.enabled,
              image : widget?.image
            },
            masterWidgetId: widget.masterWidgetId,
            widgetDataSource: dataSource
          }
          if(widget['storedType']){
            widgetPostData.widgetConfig['storedType']='default';
          }
          if(widgetPostData.widgetType == 'text' || widgetPostData.widgetType == 'imageUploader'){
            section.sectionType !== 'menuPanel' ? widgetPostData.widgetConfig['enable']=true :  widgetPostData.widgetConfig['enable'] = widget['enable'];
          }
          if(widget.widgetType == WIDGET_TYPES.navButton){
            widgetPostData.widgetConfig['image']=widget?.image;
          }
          if(widget.widgetType !== WIDGET_TYPES.button){
            widgetPostData.widgetConfig['matUiType'] = 'outlined';
          }
          else if(widget.widgetType === WIDGET_TYPES.button){
            widgetPostData.widgetConfig['matUiType'] = 'filled';
          }
          listOfWidgetsConfig.push(widgetPostData);
        })
        this.createWidget(listOfWidgetsConfig).subscribe( apiResponse => {
          let payload = {
                    applicationId : applicationId,
                    formId: formId,
                    formsWidgets: apiResponse?.['widgetIds'],
                  }  
          this.updateForm(payload,formId).subscribe( (data) => {
            observer.next(true);
            observer.complete()
          },
          (error) => {
           
            observer.error();
          })},
        (error) => {
          // this.toasterSrv.showToastMessage("Error While creating Widget", "error")
         
          observer.error();
        })
      }
    })

  }

  addMultipleWidgets(widgets:any[], formId: string, applicationId: string,form:any) : Observable<any>{
    return new Observable((observer) => {
        let listOfWidgetsConfig: any = [];
        widgets.forEach( (widget) => {
          let element = {}
          if(widget.element){
             element= {
              showLabel:widget.element.showLabel,
              isRequired:widget.element.isRequired,
              filedname:widget.element.filedname,
              placeholderText:widget.element.placeholderText,
              label:widget.element.label
  
            }
          }
           
          let dataSource = {}
          if(widget.widgetType == WIDGET_TYPES.radio){
            dataSource = {
              "datasourceType": "manual",
              "datasource": [
                  {
                      "key": "",
                      "label": "value1"
                  },
                  {
                      "key": "",
                      "label": "value2"
                  }
              ]
            }
          }
  
          let widgetPostData:any = {
            formId:formId,
            applicationId : applicationId,
            widgetLabel : widget.widgetLabel,
            widgetKey : widget.widgetKey,
            widgetType : widget.widgetType,
            widgetConfig : widget.widgetConfig,
            masterWidgetId: widget.masterWidgetId,
            widgetDataSource: dataSource
          }
          if(widgetPostData.widgetType == 'text' || widgetPostData.widgetType == 'imageUploader'){
            form.formConfig.formType !== 'menuPanel' ? widgetPostData.widgetConfig['enable']=true :  widgetPostData.widgetConfig['enable'] = widget.widgetConfig['enable'];
          }

          if(widget.widgetType == WIDGET_TYPES.navButton){
            widgetPostData.widgetConfig['image']=widget?.image;
          }
          if(widget.widgetType !== WIDGET_TYPES.button){
            widgetPostData.widgetConfig['matUiType'] = 'outlined';
          }
          else if(widget.widgetType === WIDGET_TYPES.button){
            widgetPostData.widgetConfig['matUiType'] = 'filled';
          }
          listOfWidgetsConfig.push(widgetPostData);
        })
        this.createWidget(listOfWidgetsConfig).subscribe( apiResponse => {
          let widgetIds = [...form.formConfig.formsWidgets]
          widgetIds.splice(widgetIds.length - 3, 0, ...apiResponse?.['widgetIds']);
          let payload = {
                    applicationId : applicationId,
                    formId: formId,
                    formsWidgets: [...widgetIds],
                  }  
          this.updateForm(payload,formId).subscribe( (data) => {
            observer.next(true);
            observer.complete()
          },
          (error) => {
           
            observer.error();
          })},
        (error) => {
          observer.error();
        })
    })

  }



  updateFormDetails(Form:any,bg:any,formIndex:number,pageId:string)
  {
  
    Form.formConfig.style.backgroundColor = bg;
    let page:PAGEI = this.getSelectedPage();
    page.forms[formIndex] = Form;
    this.setSelectedPage(page);
  }

  updateFormList(pageId: string, dataa: any, currentPageData: PAGEI, index: any,form:any,newlyAddedIndex:any) : Observable<any>{
    return new Observable((observer) => {
    this.pagesListSubject1.pipe(take(1)).subscribe((currentList) => {
      currentList.forEach((page: PAGEI) => {
        if (pageId === page.pageId) {
          const currentParams = { ...this.route.snapshot.queryParams };
          let dataSource = {}
          if(dataa.widgetType == WIDGET_TYPES.radio){
            dataSource = {
              "datasourceType": "manual",
              "datasource": [
                  {
                      "key": "",
                      "label": "value1"
                  },
                  {
                      "key": "",
                      "label": "value2"
                  }
              ]
            }
          }

          let widgetPostData : any = {
            formId:form.formId,
            applicationId : currentParams['id'],
            widgetLabel : dataa.element?.label ? dataa.element?.label : dataa.name,
            widgetKey : dataa.key,
            widgetType : dataa.widgetType,
            widgetConfig : {
              customStyleApplied: dataa.customStyleApplied,
              placeholderText: dataa?.element?.placeholderText,
              showlabel: dataa.element?.showLabel,
              showDeletebutton: dataa.showDeleteButton,
              style: dataa.style,
              type: dataa.type,
              image:dataa?.image ? dataa.image : '',
              validations: dataa.validations,
              actions: [],
              additionalConfig:{}
            },
            masterWidgetId: dataa.masterWidgetId,
            widgetDataSource: dataSource
          }

          if(widgetPostData.widgetType == 'text' || widgetPostData.widgetType == 'imageUploader'){
            widgetPostData.widgetConfig['enable']=true;
          }
          this.createWidget([widgetPostData]).subscribe( (data: any) => {
            if(data != null) {
              this.getPageById(pageId).subscribe((pageData: any) => {
                currentPageData = pageData;
                dataa.widgetId = data["widgetIds"]?.[0];
                let formID = currentPageData.forms[index].formId;

                if (!currentPageData.forms[index].formConfig.formsWidgets) {
                  currentPageData.forms[index].formConfig.formsWidgets = [];
                }
                currentPageData.forms[index].formConfig.formsWidgets.push(
                  dataa.widgetId
                );

                let payload = {
                  applicationId : currentParams['id'],
                  formId: formID,
                  formsWidgets:this.shiftIndexForFormUpdate(currentPageData.forms[index].formConfig.formsWidgets,newlyAddedIndex)
                  // currentPageData.forms[index].formConfig.formsWidgets,
                };
                this.updateForm(payload, formID).subscribe((res: any) => {
                   if(dataa.widgetType === WIDGET_TYPES.chatView) {
                    this.getAllPagesRefreshActionTrigger();
                   }
                    observer.next(true);
                    observer.complete()
                },(error: any)=>{
                  observer.error()
                });
              },(error:any)=>{
                observer.error()
              });
            }
          },(error)=>{
            observer.error()
          })
        }})})
      })
  }
  shiftIndexForFormUpdate(formWidgetArray:any,newlyAddedIndex:any){
    const lastElement = formWidgetArray.pop();
    formWidgetArray.splice(newlyAddedIndex, 0, lastElement);
    return formWidgetArray
  }

  updateformWidgets(formsList:FORMI[],pageId:string,formIndex:number)
  {
    const currentParams = { ...this.route.snapshot.queryParams };
    let formID;
    let formsWidgets:any[] = [];
    if(formsList[formIndex])
    {

     formID = formsList[formIndex].formId;
      formsList[formIndex].widgets?.forEach((widget) => {
        formsWidgets.push(widget.widgetId);
      })
    }
    let payload = {
      formId: formID,
      formsWidgets:formsWidgets,
      applicationId : currentParams['id']
    };
    if(formID)
    this.updateForm(payload, formID).subscribe((res) => {
       this.getPageById(pageId).subscribe((data:any) => {
       this.setSelectedPage(data);
       })
    });
  }
  updateFormWidgetsRemapCode(data:any,formId?:any){
  const currentParams:any = { ...this.route.snapshot.queryParams };
    let formID=""
    if(formId){
      formID = formId;
    }else{
     formID = data?.[0]?.formId;
    }
    let formsWidgets:any[] = [];
    data?.map((x:any)=>{
      formsWidgets.push(x?.widgetId)
    })
    let payload = {
      formId: formID,
      formsWidgets:formsWidgets,
      applicationId : currentParams['id']
    };
    if(formID){
      this.updateForm(payload, formID).subscribe((res: any) => {
     });
    }
  }
  updateSection(pageId: string, section: SECTION): void {
    let updatedList: PAGE[] = [];
  }

  removeSection(sectionIndex: number, pageId: string): void {
    let updatedPageList: PAGE[] = [];
  }

  updatePageSectionList(sections: FORMI[], pageId: string): void {
    let pagesUpdatedList: PAGEI[] = [];
  }


  addWidgetToSection(pageId: string, sectionIndex: number, widget: WIDGET): void {
    let updatedList: PAGE[] = [];
  }

  updateWidgetData(pageId: string, sectionIndex: number, widgetIndex: number, widget: WIDGET): void {
    let page:PAGEI = this.getSelectedPage();
    if(typeof(widgetIndex) == 'number') {
      page.forms[sectionIndex].widgets[widgetIndex] = widget;
      this.setSelectedPage(page);
    }
  }


  removeWidget(pageId: string, sectionIndex: number, widgetIndex: number) {
    let newPagesList: PAGE[] = [];
  }

  //#endregion


  //#region  application info
  private applicationDataSubject = new BehaviorSubject<any>({});

  applicationDataObj$: Observable<any> = this.applicationDataSubject.asObservable();

  setApplicationData(applicationData: any) {
    this.applicationDataSubject.next(applicationData);
  }

  getApplicationData()
  {
    return this.applicationDataSubject.value;
  }

  //#endregion


  //#region indicator to show if section is editable

  private displayRestrictedAreaSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  displayRestrictedArea$ = this.displayRestrictedAreaSubject.asObservable();

  setDisplayRestrictedArea(value: boolean) {
    this.displayRestrictedAreaSubject.next(value);
  }

  //#endregion

  //#region  for themes

  private themesSubject = new BehaviorSubject<THEME>({
    themeName:"M3 Baseline Light",
    primaryColor: "#0061A6",
    secondaryColor: "#6C5778",
    defaultBackgroundColor: "#FAF9FD",
    defaultTextColor: "#45474A",
  })

  themesObj: Observable<THEME> = this.themesSubject.asObservable();

  private applyWidgetStyles(widget: WIDGET, newTheme: THEME): void {
    if (widget.customStyleApplied) {
      return; // Skip if styles are already applied
    }

    switch (widget.widgetType) {
      case 'input':
        (widget.style as any)['color'] = newTheme.defaultTextColor;
        break;
      case 'button':
        (widget.style as any)['backgroundColor'] = newTheme.primaryColor;
        (widget.style as any)['color'] = newTheme.defaultTextColor;
        break;
      case 'text':
      case 'file picker':
      case 'image picker':
      case 'searchable dropdown':
      case 'select':
      case 'check box':
      case 'radio button':
      case 'date picker':
        (widget.style as any)['color'] = newTheme.defaultTextColor;
        break;
      default:
        break;
    }
  }

  clearTheme(){
    this.themesSubject.next({
      themeName:"",
      primaryColor: "",
      secondaryColor: "",
      defaultBackgroundColor: "",
      defaultTextColor: "",
    })
  }

  setThemesData(themeItemName: string, themeItemValue: string) {
    let theme: THEME = this.themesSubject.value;

    switch (themeItemName) {
      case 'themeName':
        theme.themeName = themeItemValue;
        break;
      case 'primaryColor':
        theme.primaryColor = themeItemValue;
        break;
      case 'secondaryColor':
        theme.secondaryColor = themeItemValue;
        break;
      case 'defaultBackgroundColor':
        theme.defaultBackgroundColor = themeItemValue;
        break;
      case 'defaultTextColor':
        theme.defaultTextColor = themeItemValue;
        break;
      case 'headingFont':
        theme.headingFont = themeItemValue;
        break;
      case 'bodyFont':
        theme.bodyFont = themeItemValue;
        break;
      default:
        return;
    }
    this.themesSubject.next(theme);
    this.updateThemeForApplication(theme);
  }

  updateWholeTheme(themeData:any){
    let theme: THEME = this.themesSubject.value;

    theme.themeName = themeData.themeName ?? theme.themeName;
    theme.primaryColor = themeData.primaryColor ??  theme.primaryColor;
    theme.secondaryColor = themeData.secondaryColor ?? theme.secondaryColor;
    theme.defaultBackgroundColor = themeData.defaultBackgroundColor ?? theme.defaultBackgroundColor;
    theme.defaultTextColor = themeData.defaultTextColor ?? theme.defaultTextColor;
    theme.headingFont = themeData.headingFont ?? theme.headingFont;
    theme.bodyFont = themeData.bodyFont ?? theme.bodyFont;
    this.setThemeData(theme);
    this.themesSubject.next(theme);
  }

  
  updateThemeForApplication(newTheme: THEME) {
    let pages = this.pagesListSubject1.value;
    pages.forEach((page: PAGEI) => {
      if(page.pageConfig && page.forms)
      {
      (page.pageConfig?.style as any).backgroundColor = newTheme.defaultBackgroundColor;

      page.forms.forEach((section: FORMI) => {
        if(section.formConfig?.formType === "Navgation Bar")
        {
          (section.formConfig.style as any)['backgroundColor'] = newTheme.primaryColor;
        }
        else{
        (section.formConfig?.style as any)['backgroundColor'] = newTheme.secondaryColor;
        }
        if(section.widgets)
        section.widgets.forEach((widget) => {
          this.applyWidgetStyles(widget,newTheme);
        })
      })
    }

    })
    // this.formatAppBeforeUpdate(pages);
    this.pagesListSubject1.next(pages);
  }
  //#endregion

  setApplicationDataById(data: any) {
    this.applicationMetaInfo = data;
  }

  getApplicationDataById() {
    return this.applicationMetaInfo;
  }
  //#region pages expanstion panel opener

  private expansionPanelStatesSubject = new BehaviorSubject<exapansionpaneldetails>({pageID:'',sectionIndex:-1})

  expansionPanelStatesObj: Observable<exapansionpaneldetails> = this.expansionPanelStatesSubject.asObservable();

  getPagesExpansionPanelOpener()
  { 
    return this.expansionPanelStatesSubject.value;
  }

  setPagesExpansionPanelOpener(data:exapansionpaneldetails)
  {
    this.expansionPanelStatesSubject.next(data)
  }
  //#endregion
  
  createForm(formPostData: any) : any{
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_FORM']);
    apiConfig.postData = formPostData;
    apiConfig.postData['createdBy'] = this.userMetaInfo?.userId
    return this.httpService.placeAPICall(apiConfig)
  }

  updateForm(formPostData: any, formId: string){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_FORM']);
    apiConfig.postData = formPostData;
    apiConfig.postData['userId'] = this.userMetaInfo?.userId;
    apiConfig.postData['formId'] = formId;
    return this.httpService.placeAPICall(apiConfig);
  }

  createWidget(widgetPostData: any) : Observable<any>{
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    apiConfig.postData = widgetPostData;
    return this.httpService.placeAPICall(apiConfig);
  }

  createDropedPage(payload: any){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_PAGE']);
    apiConfig.postData = payload;
    return this.httpService.placeAPICall(apiConfig);
  }
  updateWidget(widgetPostData: any,widgetId: any){
    const currentParams = { ...this.route.snapshot.queryParams };
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    apiConfig.postData = widgetPostData;
    apiConfig.postData['widgetId'] = widgetId;
    apiConfig.postData['userId'] = this.userMetaInfo?.userId;
    apiConfig.postData['applicationId'] = currentParams['id'];
    return this.httpService.placeAPICall(apiConfig);
  }
  deleteWidget(currentPageData: any, formIndex: any, widgetId: any, previewPageId?:any){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_WIDGET']);
    apiConfig.postData = { widget_id:widgetId };

    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        if(previewPageId){
          this.getAllPagesRefreshActionTrigger();
        }
      },
      error: (data: any) => {

      }
    })
  }

  updateWidgetImage(image:any, widgetId: any,key?:string): any{
    const currentParams = { ...this.route.snapshot.queryParams };
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['ADD_OR_UPDATE_WIDGET_IMAGE']);
    apiConfig.postData = {};
    apiConfig.postData['widgetId'] = widgetId;
    apiConfig.postData['image'] = image;
    if(key){
    apiConfig.postData['key'] = key;
    }
    apiConfig.postData['applicationId'] = currentParams['id'];
    return new Promise<any>((resolve, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          resolve({response:response,status:true}); 
        },
        error: (error: Error) => {
          reject({response:error,status:false});
        }
      })
    })
  }

  deleteForm(formId: string, currentPage: any): Observable<any> {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_FORM']);
      apiConfig.postData = { form_id: formId };
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          const currentParams = { ...this.route.snapshot.queryParams };
            observer.next(true);
            observer.complete();
        },
        error: (data: any) => {
        observer.error()
        }
      })
  })
  }


  private selectedPageSubject = new BehaviorSubject<PAGEI>({pageId:'',pageName:'',applicationId:''});

  selectedPageObj$: Observable<PAGEI> = this.selectedPageSubject.asObservable();

  setSelectedPage(data:PAGEI)
  {
    this.selectedPageSubject.next(data);
  }

  getSelectedPage()
  {
   return this.selectedPageSubject.value;
  }


  private setLastSelectedSideNavOption = new Subject<string>();
  setLastSelectedSideNavOption$: Observable<string> = this.setLastSelectedSideNavOption.asObservable();

  setSelectedOptionAsLastedSelected(option: string) {
    localStorage.setItem(LAST_SELECTED_OPTION,option);
    this.setLastSelectedSideNavOption.next(option);
  }


  //#region  dropdown datasource

  private dataSourceApiValues = new BehaviorSubject<{widgetId:string,responce:any,field:any}>({widgetId:"",responce:[],field:""});

  dataSourceApiValues$: Observable<{widgetId:string,responce:any,field:any}> = this.dataSourceApiValues.asObservable();

  setDataSourceApiValues(apiValues :{widgetId:string,responce:any,field:any}){
    this.dataSourceApiValues.next(apiValues);
  }

  getDataSourceApivales(){
    return this.dataSourceApiValues.value;
  }
  setThemeData(themeData:any){
    this.themeData=themeData;
  }
  getThemeData(){
    return this.themeData;
  }
  clearThemeData(){
    this.themeData = null;  
  };

  private applicationNameSubject = new BehaviorSubject<string>('');
  currentApplicationName$ = this.applicationNameSubject.asObservable();

  updateApplicationName(newName: string) {
    this.applicationNameSubject.next(newName);
  }
  
  setApplicationDataEntire(appData:any){
    this.entireAppData = appData;
  }
  getApplicationDataEntire(){
    return this.entireAppData;
  }

  setStepperIndexValue(apiCalled: boolean) {
    this.stepperIndexSource.next(apiCalled);
  }
  //#endregion

  formatedSectionData(pageData: any, applicationTheme: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let data: any = CATEGORIES_META_DATA[0]?.items[0];
      const timeStamp = '-CD-' + Date.now();
      if (data.sectionType === "Navgation Bar") {
        if (data && data.style) {
          data.key = pageData.pageName + 0 + '-NavBar' + 0 + timeStamp;
          data.style.backgroundColor = applicationTheme.primaryColor;
        }
      } else if (data.sectionType === "menuPanel") {
        if (data && data.style) {
          data.key = pageData.pageName + 0 + '-manuPanel' + 0 +timeStamp;
          data.style.backgroundColor = applicationTheme.primaryColor;
        }
      } else {
        if (data && data.style) {
          data.key = pageData.pageName + 0 + "Customform" + 0 +timeStamp;
          data.style.backgroundColor = applicationTheme.secondaryColor;
        }
      }
      let count = 1;
      data.widgets.forEach((widget: WIDGET) => {
        widget.key = pageData.pageName + 0 + "-form" + 0 + "-" + widget.name.slice(0, 2) + count + timeStamp;
        this.applyWidgetStyles(widget, applicationTheme);
        count++;
      });
      if (pageData.pageId) {
        this.addSection(pageData.pageId as string, data, pageData).subscribe(
          (data: any) => {
            resolve();
          },
          (error) => {
            reject(error);
            this.toastrSer.error("Error while adding widget");
          }
        );
      } else {
        resolve();
      }
    });
  }

  async fetchEntity(id:String,type:any) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);
    apiConfig.postData = type == 'application' ? {
      application_id: id,
      entity_id: null,
      project_id: null,
      parent_entity_id: null
    } : {page_id:id}
    const returnData: any = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          resolve(response.data);
        },
        complete: () => {},
        error: (error: any) => {
          reject(error);
        } 
      });
    });  
    return returnData;
  }
  saveEntiy(type:any,postData:any,applicationId?:any,entityForm?:any,newPageId?:any,) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPDATE_ENTITY']);
    apiConfig.postData = type != 'edit' ? {
      entity_id: entityForm?.entity_id ? entityForm?.entity_id : null,
      entity_name: entityForm?.entity_name ? entityForm?.entity_name : entityForm,
      child_entity_ids_relation: entityForm?.child_entity_ids_relation ? entityForm?.child_entity_ids_relation : null,
      application_id: applicationId,
      page_ids_list: entityForm?.page_ids_list ? entityForm?.page_ids_list : [newPageId],
      removal_page_ids_list: entityForm?.removal_page_ids_list ? entityForm?.removal_page_ids_list : [],
      removal_child_entity_ids_relation: entityForm?.removal_child_entity_ids_relation ? entityForm?.removal_child_entity_ids_relation : []
    } :postData
    return new Observable((observer) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data); 
          observer.complete();
        },
        error: (data: any) => {
          observer.error(data); 
          observer.complete(); 
        }
      })})
  }

  fetchWorkFlows(entityId: string, type: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['WORKFLOW_FETCH']);
    apiConfig.postData = {
      fetch_type: type,
      fetch_id: entityId
    }
    return new Promise<any>((resolve, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          resolve(response.response); 
        },
        error: (error: Error) => {
          reject(error);
        }
      })
    })
  }

  getModifiedImageUrl(binaryImage:string){
    const validPrefixes = ["mobiwise.s3", "data:image/", "blob:"];
    if (validPrefixes.some((prefix) => binaryImage.includes(prefix))) {
      return binaryImage;
    }
    return `data:image/png;base64,${binaryImage}`;
  }

  resetSelectedApplicationData(){
    this.pagesListSubject1.next([]);
    this.applicationDataSubject.next({});
    this.selectedPageSubject.next({pageName:''});
    this.selectedOptionSubject.next({label:'',isActive:false});
  }
}


interface SidenavOption {
  label: string;
  isActive: boolean;
}


interface SideNavOptionForPages {
  id: string,
  isActive: boolean
}

interface exapansionpaneldetails {
  pageID: string;
  sectionIndex: number;
  widgetIndex?: number;

}